const LocalStorageWrapper = {
	get<Type>(key: string): Type | null {
		try {
			const json = localStorage.getItem(key);
			if (json) {
				const value: Type = JSON.parse(json);
				return value;
			}
			return null;
		} catch (error) {
			return null;
		}
	},
	set(key: string, value: unknown) {
		try {
			const json = JSON.stringify(value);
			localStorage.setItem(key, json);
			return true;
		} catch (error) {
			return false;
		}
	},
	remove(key: string) {
		localStorage.removeItem(key);
	},
	clear() {
		localStorage.clear();
	},
};

export const LocalStorageKeys = {
	THEME: 'Theme',
	LOCALE: 'Locale',
	USER: 'User',
	COUNTER: 'counter',
	REFRESH_TOKEN: '__AGHS_HGD',
	HASH: '_HASGFET_HJSH',
	INACTIVITY_TIMEOUT: '_HDHAGHJWYUBNXA_DHSJKA',
	CACHE: 'DOJSHGE_DJHAJHJS',
};

export default LocalStorageWrapper;
